import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Grid, Tooltip, IconButton, Switch } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";

export default class FaqList extends Component {
  state = {
    faqs: [],
    per_page: 10,
    page: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      limit: 10,
    },
    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
  };

  componentDidMount() {
    this.fetchFaqs(this.state.page, this.state.per_page);
  }

  // ✅ FETCH (POST API FIXED)
  fetchFaqs = (page = 1, limit = 10) => {
    if (init() !== "success") return;

    this.setState({ loading: true });

    axios
      .post(Constants.getUrls.getAllFaqs, { page, limit })
      .then((resp) => {
        if (resp.data.status) {
          const data = resp.data.data;
          const rows = data.rows || [];

          this.setState({
            faqs: rows,
            pagination: {
              page: data.pagination.currentPage,
              limit: data.pagination.limit,
              totalDocs: data.pagination.total,
              totalPages: data.pagination.totalPages,
              hasNextPage: data.pagination.hasNextPage,
              hasPrevPage: data.pagination.hasPrevPage,
            },
            loading: false,
          });
        } else {
          this.setState({
            notification: true,
            message: resp.data.message,
            notiColor: "warning",
            loading: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          notification: true,
          message: "Something went wrong",
          notiColor: "warning",
          loading: false,
        });
      });
  };

  // ✅ DELETE (POST FIXED)
  handleDelete = (id) => {
    if (!window.confirm("Delete this FAQ?")) return;

    axios
      .post(Constants.deleteUrls.deleteFaq, { id })
      .then((resp) => {
        this.setState({
          notification: true,
          message: resp.data.message || "Deleted",
          notiColor: "success",
        });

        this.fetchFaqs(this.state.pagination.page, this.state.per_page);
      });
  };

  // ✅ STATUS TOGGLE (ADDED)
  handleStatus = (id, status) => {
    const newStatus = status === "1" ? "0" : "1";

    axios
      .post(Constants.putUrls.changeFaqStatus, {
        id,
        status: newStatus,
      })
      .then(() => {
        this.fetchFaqs(this.state.pagination.page, this.state.per_page);
      });
  };

  handlePageChange = (page) => {
    this.fetchFaqs(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.fetchFaqs(1, limit);
    });
  };

  render() {
    const { faqs, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                FAQ Questions
              </MDTypography>
            </MDBox>

            {/* ADD BUTTON */}
            <Grid item sm={4} px={2} align="right">
              <Link to="/addfaq">
                <MDButton variant="contained" size="small" color="primary">
                  Create New
                </MDButton>
              </Link>
            </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : faqs.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Question", accessor: "question" },
                      { Header: "Answer", accessor: "answer" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],

                    rows: faqs.map((faq, i) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit +
                        (i + 1),

                      question: faq.question || "-",
                      answer:
                        faq.answer?.length > 70
                          ? faq.answer.substring(0, 70) + "..."
                          : faq.answer || "-",

                      status: (
                        <Switch
                          checked={faq.status === "1"}
                          onChange={() =>
                            this.handleStatus(faq.id, faq.status)
                          }
                        />
                      ),

                      action: (
                        <div style={{ display: "flex", gap: 10 }}>
                          <Tooltip title="Edit">
                            <Link to={`/updatefaq/${faq.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>

                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={() => this.handleDelete(faq.id)}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={this.handleEntriesPerPageChange}
                />
              ) : (
                <div style={{ padding: 20 }}>No Data Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="FAQ"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}